import { canViewHistoryApprovals } from '../features/dynamictabs/historyCorrections'
import React, { useContext, useEffect, useState } from 'react'
import DashboardNavigation from '../components/3modules/DashboardNavigation'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { AuthorizationError, reExportedColors } from '../components/1elements/'
// import FeatureSetTable from '../components/3modules/AdminDashboard/FeatureSetTable'
// import ResourceSetTable from '../components/3modules/AdminDashboard/ResourceSetTable'
// import PeopleManagementTable from '../components/3modules/AdminDashboard/PeopleManagementTable'
// import UserManagementTable from '../components/3modules/AdminDashboard/UserManagementTable'
//import GroupManagement from './adminDashboard/GroupManagement'
import { GlobalContext } from '../services/context/DataContext'
import UserManagement from './UserManagement'
import BulkImport from '../v2/pages/BulkImport';
import ApprovalsPage from './ApprovalsPage'
import {
  isAllowedToView,
  isAllowedToImport,
  isAllowedToPerformFeature,
  isAllowedToViewAdminAccess,
} from '../services/permissions/permissionHelper'
import DataExport from './dataExport/DataExport'
import AuditLog from './auditLog/AuditLog'
import AppearanceConfiguration from '../components/5templates/AppearanceConfiguration'
import ApplicationConfiguration from '../components/5templates/ApplicationConfiguration'
import MapConfiguration from '../components/5templates/MapConfiguration'
import RefrenceConfiguration from '../components/5templates/ReferenceDataConfiguration'
import DataViewConfiguration from '../components/5templates/DataViewConfiguration'
import LayoutConfiguration from '../components/5templates/LayoutsConfiguration'
import FieldsConfiguration from '../components/5templates/FieldsConfiguration'
import DashboardManagement from '../features/dashboard-v1/DashboardManagement'
import HistoricalDataSettings from '../features/dynamictabs/HistoricalDataSettings'
import { canViewDashboardApprovals } from '../features/dashboard-v1/dashboardPermissions'

import MixedGroups from '../features/groups/access-management'
import OperationalGroups from '../features/groups/operational-groups'
import FeatureGroups from '../features/groups/feature-groups'
import UserGroups from '../features/groups/user-groups'
import TerritoryGroups from '../features/groups/territory-groups'

import CommercialZones from '../features/datazones/commercial-zones'
import GeoZones from '../features/datazones/geo-zones'
import CommingSoon from './commingSoon'
import ResourceSummary from '../features/assets/resources/Summary'

import AccountSummary from '../features/assets/accounts/Summary'
import LocationSummary from '../features/assets/locations/LocationSummary'
import BuildingSummary from '../features/assets/locations/BuildingSummary'

import PeopleEntry from '../features/assets/parties/PeopleEntry'

import UserEntry from '../features/assets/parties/UserEntry'

import ServiceSummary from '../features/assets/services/Summary'
import SkillsetSummary from '../features/assets/skillsets/Summary'
import {
  getRememberedActiveAdminMenu,
  rememberActiveAdminMenu
} from '../features/adminSideMenu/util/activeAdminMenu'

const useStyles = makeStyles((theme, props) => ({
  collapseIcon: {
    position: 'absolute',
    top: '10px',
    left: '-14px',
    width: '27px',
    transition: 'transform .5s'
  },
  layout: {
    marginLeft: props => (props.showSidePanel ? '61px' : '0px'),
    height: '100vh',
    minHeight: 0,
    overflow: 'hidden',
    boxSizing: 'border-box',
    '@supports (height: 100dvh)': {
      height: '100dvh'
    },
    width: '100%',
    paddingRight: props => (!props.isCommigSoon ? 20 : 0),
    display: 'grid',
    gridGap: props => (!props.isCommigSoon ? '20px' : '0px'),
    gridTemplateColumns: 'auto 12fr',
    gridTemplateRows: 'minmax(0, 1fr)',
    background: theme.palette.quaternary.main
  },
  HeadName: {
    fontSize: '22px',
    fontWeight: 'bold',
    fontFamily: 'Lato',
    color: reExportedColors.TEXT, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    gridColumn: 'span 3 / -1'
  },
  verticalLine: {
    borderLeft: `1px solid ${reExportedColors.LIGHT_GREY}`, /// /// HARDCODED TO USE CONSTS - to be Assigned a palette color
    height: '100%',
    position: 'relative'
  },
  sideBarClosed: {
    '&$layout': {
      gridTemplateColumns: 'auto 0.1fr 12fr'
    },
    '& $collapseIcon': {
      transform: 'rotate(180deg)'
    }
  },
  mainDiv: {
    marginTop: props => (!props.isCommigSoon ? 33 : 0),
    minHeight: 0,
    minWidth: 0,
    overflow: 'auto',
    overscrollBehavior: 'contain'
  }
}))

export default function AdminDashboard () {
  const { activeTabData, sidePanelState } = useContext(GlobalContext)
  const [activeTab, setActiveTab] = activeTabData
  const [showSidePanel, setShowSidePanel] = sidePanelState
  const viewAdminAccessPermission = isAllowedToViewAdminAccess()
  const [content, setContent] = useState(<></>)
  const [isNavigationOpen, setIsNavigationOpen] = useState(true)
  const [isCommigSoon, setIsCommingSoon] = useState(false)
  const classes = useStyles({ isNavigationOpen, isCommigSoon, showSidePanel })

  const viewImport = () => {
    var canView = false
    const importTypes = [
      'service',
      'party',
      'dashboard',
      'asset'
    ]

    for(var i = 0; i < importTypes.length; i++)
    {
      if(isAllowedToImport(importTypes[i])) { canView = true}
    }

    return canView
  }

  const viewExport = () => {
    var canView = false
    const exportTypes = [
      'audit',
      'business',
      'master'
    ]

    for (var i = 0; i < exportTypes.length; i++)
    {
      if(isAllowedToPerformFeature(`export.${exportTypes[i]}`)) { canView = true }
    }

    return canView
  }

  useEffect(() => {
    setIsCommingSoon(false)
  }, [activeTab])

  const getActiveTab = () => {
    const commingSoonTabs = {
      0: 'Organizational Access',
      21: 'Resources',
      23: 'Locations',
      25: 'Services',
      26: 'Skill Sets',
      45: 'Alerts',
      47: 'Notifications',
      65: 'Audit Log',
      77: 'Adapters and Integrations',
      85: 'Heat Maps',
      86: 'Image Management'
    }

    switch (activeTab) {
      // Organizational Access
      // access management

      case '03': //mixed groups directly through access-management
        setContent(<MixedGroups />)
        break

      case '033': //operational groups
        viewAdminAccessPermission || isAllowedToView('group.operational')
          ? setContent(<OperationalGroups />)
          : setContent(<AuthorizationError />)
        break

      case '035': //user groups
        viewAdminAccessPermission || isAllowedToView('group.user')
          ? setContent(<UserGroups />)
          : setContent(<AuthorizationError />)
        break
      case '037': //feature groups
        viewAdminAccessPermission || isAllowedToView('group.feature')
          ? setContent(<FeatureGroups />)
          : setContent(<AuthorizationError />)
        break
      case '039': //territory groups
        viewAdminAccessPermission || isAllowedToView('group.territory')
          ? setContent(<TerritoryGroups />)
          : setContent(<AuthorizationError />)
        break

      case '0393': //commercial zones
        viewAdminAccessPermission || isAllowedToView('datazone.commercial')
          ? setContent(<CommercialZones />)
          : setContent(<AuthorizationError />)
        break

      case '0395': //geo zones
        viewAdminAccessPermission || isAllowedToView('datazone.geo')
          ? setContent(<GeoZones />)
          : setContent(<AuthorizationError />)
        break

      // asset management
      case '20': //resources => renamed to Entities
        viewAdminAccessPermission || isAllowedToView('entities')
          ? setContent(<ResourceSummary />)
          : setContent(<AuthorizationError />)
        break
      case '21': //accounts
        viewAdminAccessPermission || isAllowedToView('contract')
          ? setContent(<AccountSummary />)
          : setContent(<AuthorizationError />)
        break
      case '22': //users
        viewAdminAccessPermission || isAllowedToView('user')
          ? setContent(<UserEntry />)
          : setContent(<AuthorizationError />)
        break
      case '23': //locations
        viewAdminAccessPermission || isAllowedToView('asset')
          ? setContent(<LocationSummary />)
          : setContent(<AuthorizationError />)
        break
      case '27': //locations
        viewAdminAccessPermission || isAllowedToView('asset')
          ? setContent(<BuildingSummary />)
          : setContent(<AuthorizationError />)
        break

      case '24': //people
        viewAdminAccessPermission || isAllowedToView('party')
          ? setContent(<PeopleEntry />)
          : setContent(<AuthorizationError />)
        break
      case '25': //service
        viewAdminAccessPermission || isAllowedToView('service')
          ? setContent(<ServiceSummary />)
          : setContent(<AuthorizationError />)
        break

      case '26': //skillset
        viewAdminAccessPermission || isAllowedToView('skillset')
          ? setContent(<SkillsetSummary />)
          : setContent(<AuthorizationError />)
        break

      // event management
      case '43': //approvals
        viewAdminAccessPermission || isAllowedToView('approvals') || canViewDashboardApprovals() || canViewHistoryApprovals()
          ? setContent(<ApprovalsPage />)
          : setContent(<AuthorizationError />)
        break

      //reporting
      case '63': // user activity
        viewAdminAccessPermission || isAllowedToView('activity')
          ? setContent(<UserManagement />)
          : setContent(<AuthorizationError />)
        break

      case '65': // Audit Log
        viewAdminAccessPermission || isAllowedToView('audit')
          ? setContent(<AuditLog />)
          : setContent(<AuthorizationError />)
        break

      // data management
      case '73': //import
        viewAdminAccessPermission || viewImport()
          ? setContent(<BulkImport />)
          : setContent(<AuthorizationError />)
        break

      case '75': //export
        viewAdminAccessPermission || viewExport()
          ? setContent(<DataExport />)
          : setContent(<AuthorizationError />)
        break

      //settings
      case '81': // Themes
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.themes.view')
          ? setContent(<AppearanceConfiguration />)
          : setContent(<AuthorizationError />)
        break

      case '82': // Templates
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.templates.view')
          ? setContent(<ApplicationConfiguration />)
          : setContent(<AuthorizationError />)
        break

      case '83': // Markers
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.markers.view')
          ? setContent(<MapConfiguration />)
          : setContent(<AuthorizationError />)
        break

      case '84': //Dynamic fields
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.datafields.view')
          ? setContent(<DataViewConfiguration />)
          : setContent(<AuthorizationError />)
        break

      case '85': //Refrence Data (Note we don't have a permission created for this yet)
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.refrence.view') || true
          ? setContent(<RefrenceConfiguration />)
          : setContent(<AuthorizationError />)
        break
      
      case '86': //Temporary Menu for Dynamic Fields until ready to replace the current one
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.datafields.view')
          ? setContent(<LayoutConfiguration />)
          : setContent(<AuthorizationError />)
        break
      
      case '87': //FieldManager
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.datafields.view')
          ? setContent(<FieldsConfiguration />)
          : setContent(<AuthorizationError />)
        break

      case '88': // Dashboards
        setContent(<DashboardManagement />)
        break

      case '89': // Historical data
        viewAdminAccessPermission || isAllowedToPerformFeature('settings.datafields.view')
          ? setContent(<HistoricalDataSettings />)
          : setContent(<AuthorizationError />)
        break

      default:
        setIsCommingSoon(true)
        setContent(
          Object.keys(commingSoonTabs).includes(activeTab) ? (
            <CommingSoon sectionName={commingSoonTabs[activeTab]} />
          ) : (
            <CommingSoon />
          )
        )
        break
    }
  }

  useEffect(() => {
    getActiveTab()
    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [activeTab])

  useEffect(() => {
    rememberActiveAdminMenu(activeTab)
  }, [activeTab])

  useEffect(() => {
    setShowSidePanel(false)
    const selectedColor = localStorage.getItem('tempColorSelect')
    const mapCentralization = localStorage.getItem('tempMapCentralization')
    let nextActiveTab = activeTab || getRememberedActiveAdminMenu() || '20'

    if (selectedColor) {
      nextActiveTab = '12'
    }
    if (mapCentralization) {
      nextActiveTab = '19'
    }

    if (nextActiveTab !== activeTab) setActiveTab(nextActiveTab)

    return () => {
      setShowSidePanel(true)
    }
    // XXX Fix this in the future
    // eslint-disable-next-line
  }, [])

  return (
    <div className={classes.layout}>
      <DashboardNavigation
        isNavigationOpen={isNavigationOpen}
        setIsNavigationOpen={setIsNavigationOpen}
      />
      <div className={classes.mainDiv}>{content}</div>
    </div>
  )
}
